import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-info-alert',
  templateUrl: './info-alert.component.html',
  styleUrls: ['./info-alert.component.scss']
})
export class InfoAlertComponent {

  @Input() message!: string;

}
